import { PUBLIC_PATH } from "./index";

const HOME_URL = `${PUBLIC_PATH}/`;

export { HOME_URL };
